import {call, put} from "typed-redux-saga";
import Api from "modules/utils/Api";
import {fetchRewardStatsSuccess} from "modules/actions/rewardStats";

export const fetchRewardStatsSaga = function* () {
	const rewardStats = yield* call(Api.Jsons.reward_stats);

	yield* put(fetchRewardStatsSuccess(rewardStats.data));
};

export default fetchRewardStatsSaga;
